

define(['jquery', 'angular', 'squid/index', 'text!./template.html', 'components/xo-models/src/bml/index', 'components/xo-page-components/src/value-props/directive', 'components/xo-title/dist/directive', 'components/xo-ui-components/src/message/directive', 'components/xo-ui-components/src/error-tooltip/directive'], function ($, angular, squid, template) {

    return angular.module('xo-bml-signature.directive', ['squid', 'xomodel.bml', 'xo-value-props.directive', 'xo-title.directive', 'xo-message.directive', 'xo-error-tooltip.directive']).directive('xoBmlSignaturePage', function () {

        return {
            template: template,

            controller: function controller($scope, $AuthModel, $populate, $state, $rootScope, $BMLApplicationModel) {
                $populate($scope, {
                    auth: $AuthModel.instance()
                }).then(function () {

                    $scope.init = function () {
                        $('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
                        $('.paypalHeaderWrapper').addClass('paypalCredit');
                        $('.paypalHeader').removeClass('span14');
                        $('.paypalHeader').addClass('span24');
                        $('.paypalHeader').addClass('headerBar');
                        $scope.token = $rootScope.token;
                        $scope.bmlSign = new $BMLApplicationModel();
                    };

                    $scope.onSubmit = function () {
                        var application_id = $scope.bml.application_id;
                        $scope.bmlSign.application_id = application_id;
                        $scope.bmlSign.action('sign', {

                            resultModel: $scope.bml,

                            success: function success(result) {
                                $state.go('checkout.review');
                            }
                        });
                    };

                    $scope.redirectToReview = function () {
                        $state.go('checkout.review');
                    };

                    $scope.init();
                });
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-credit-components/src/bml-display/xo-bml-signature/directive.js
// module id = ./components/xo-credit-components/src/bml-display/xo-bml-signature/directive.js
// module chunks = 1